import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {TopExposure} from '../../../../../models/influencer';
import {Platform} from '../../../../../models/platform';
import {CommonConstant} from '../../../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {ObjectUtils} from '../../../../utils/object.utils';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'influencer-top-exposures',
  templateUrl: './influencer-top-exposures.component.html',
  styleUrls: ['./influencer-top-exposures.component.scss']
})
export class InfluencerTopExposuresComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'TopExposuresComponent';
  @Input() topExposures: TopExposure[] = [];
  @Input() platformList: Platform[] = [];
  @Input() forPayingUser = false;
  @Input() printMode: boolean;
  @Input() isFetchingData: boolean;

  constructor(private translate: TranslateService,
              private pdfService: PdfExportService,
              private userService: UserService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.topExposures.length === 0) {
      this.pdfService.incrementNumberReportReady(InfluencerTopExposuresComponent.COMPONENT_NAME);
    } else {
      this.pdfService.imagedLoadedTrigger.subscribe(data => {
        if (data.component === InfluencerTopExposuresComponent.COMPONENT_NAME
          && data.currentCounter === this.topExposures.length) {
          this.pdfService.incrementNumberReportReady(InfluencerTopExposuresComponent.COMPONENT_NAME);
        }
      });
    }
  }

  public getExposureType(exposureIndex: number) {
    switch (exposureIndex) {
      case CommonConstant.REACH_EXPOSURE_INDEX:
        return this.translate.instant('INFLUENCER.insight.top_exposure.reach');
      case CommonConstant.ENGAGEMENT_EXPOSURE_INDEX:
        return this.translate.instant('INFLUENCER.insight.top_exposure.engagement');
      case CommonConstant.IMPACT_EXPOSURE_INDEX:
        return this.translate.instant('INFLUENCER.insight.top_exposure.impact');
    }
  }

  get hasNoData() {
    if (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin) {
      return true;
    }
    if (this.topExposures.length === 0) {
      return true;
    }
    const noneEmptyExposures = this.topExposures.filter(te => !ObjectUtils.isEmpty(te));
    return noneEmptyExposures.length === 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposures.component.ts